"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnyCreatableFlashcardBackType = exports.AnyCreatableFlashcardBackTypeSchema = exports.AnyFlashcardBackTypeSchema = exports.isAnySentenceFlashcardBackType = exports.AnySentenceFlashcardBackTypeSchema = exports.isAnyNonBootcampSentenceFlashcardBackType = exports.AnyNonBootcampSentenceFlashcardBackTypeSchema = exports.WordToSentenceRootTypeSchema = exports.WordToSentenceTypeSchema = exports.WordToPicFlashcardBackTypeSchema = exports.BootcampWordToSentenceFlashcardBackTypeSchema = exports.getFlashcardBackTypeIdFromName = exports.flashcardBackTypeIdToFlashcardBackTypeNameMap = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
// Bootcamp flashcard backs are not stored as separate entities in the DB,
// so they don't have associated IDs.
exports.flashcardBackTypeIdToFlashcardBackTypeNameMap = Object.freeze({
    1: "WORD_TO_PIC",
    2: "WORD_TO_SENTENCE",
    3: "WORD_TO_SENTENCE_ROOT",
});
const getFlashcardBackTypeIdFromName = (type) => {
    const keys = Object.keys(exports.flashcardBackTypeIdToFlashcardBackTypeNameMap);
    return parseInt(keys.find((key) => exports.flashcardBackTypeIdToFlashcardBackTypeNameMap[key] === type), 10);
};
exports.getFlashcardBackTypeIdFromName = getFlashcardBackTypeIdFromName;
exports.BootcampWordToSentenceFlashcardBackTypeSchema = zod_1.z.literal("UGC_WORD_TO_SENTENCE");
exports.WordToPicFlashcardBackTypeSchema = zod_1.z.literal("WORD_TO_PIC");
exports.WordToSentenceTypeSchema = zod_1.z.literal("WORD_TO_SENTENCE");
exports.WordToSentenceRootTypeSchema = zod_1.z.literal("WORD_TO_SENTENCE_ROOT");
exports.AnyNonBootcampSentenceFlashcardBackTypeSchema = zod_1.z.union([
    exports.WordToSentenceRootTypeSchema,
    exports.WordToSentenceTypeSchema,
]);
exports.isAnyNonBootcampSentenceFlashcardBackType = type_validation_helpers_1.getTypeValidationFunction(exports.AnyNonBootcampSentenceFlashcardBackTypeSchema);
exports.AnySentenceFlashcardBackTypeSchema = zod_1.z.union([
    exports.AnyNonBootcampSentenceFlashcardBackTypeSchema,
    exports.BootcampWordToSentenceFlashcardBackTypeSchema,
]);
exports.isAnySentenceFlashcardBackType = type_validation_helpers_1.getTypeValidationFunction(exports.AnySentenceFlashcardBackTypeSchema);
exports.AnyFlashcardBackTypeSchema = zod_1.z.union([
    exports.AnySentenceFlashcardBackTypeSchema,
    exports.WordToPicFlashcardBackTypeSchema,
]);
exports.AnyCreatableFlashcardBackTypeSchema = zod_1.z.union([
    exports.AnySentenceFlashcardBackTypeSchema,
    exports.WordToPicFlashcardBackTypeSchema,
]);
exports.isAnyCreatableFlashcardBackType = type_validation_helpers_1.getTypeValidationFunction(exports.AnyCreatableFlashcardBackTypeSchema);
//# sourceMappingURL=flashcard_back_type_types.js.map